<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_0_66" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="23.9999" height="23.9999" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_0_66)">
      <path
        d="M4.10035 23.9999C3.51715 23.9999 3.02115 23.7959 2.61235 23.3879C2.20435 22.9791 2.00036 22.4831 2.00036 21.8999C2.00036 21.3167 2.20435 20.8207 2.61235 20.4119C3.02115 20.0039 3.51715 19.7999 4.10035 19.7999H19.8995C20.4827 19.7999 20.9787 20.0039 21.3875 20.4119C21.7955 20.8207 21.9995 21.3167 21.9995 21.8999C21.9995 22.4831 21.7955 22.9791 21.3875 23.3879C20.9787 23.7959 20.4827 23.9999 19.8995 23.9999H4.10035ZM5.45034 17.9747C5.16714 17.9747 4.92114 17.8707 4.71234 17.6627C4.50434 17.4539 4.40034 17.2079 4.40034 16.9247V14.4743C4.40034 14.3415 4.42514 14.2127 4.47474 14.0879C4.52514 13.9623 4.60034 13.8495 4.70034 13.7495L13.1255 5.32557L17.0495 9.24955L8.62552 17.6747C8.52472 17.7747 8.41192 17.8499 8.28712 17.9003C8.16233 17.9499 8.03313 17.9747 7.89953 17.9747H5.45034ZM18.3251 7.97516L14.3999 4.04998L16.1495 2.30039C16.3495 2.10039 16.6079 2.00039 16.9247 2.00039C17.2415 2.00039 17.4999 2.10039 17.6999 2.30039L20.1995 4.79997C20.3827 4.98317 20.4535 5.22077 20.4119 5.51277C20.3703 5.80397 20.2579 6.04157 20.0747 6.22556L18.3251 7.97516Z"
        :fill="fill"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface EditErudioIconProps {
  fill?: string;
}

withDefaults(defineProps<EditErudioIconProps>(), {
  fill: '#FFF',
});
</script>
